export default "__VITE_ASSET__519cf687__"